<template>
  <container
    subHeaderTitle="세이프빌링<br /><b>가입하기</b>"
    subHeaderText="서비스 가입 전 이용약관을 반드시 읽어보시고,<br />가입하시는 분의 정보를 정확히 입력하시기 바랍니다."
    subHeaderAlign="center"
  >
    <template v-slot="{showTerms}">
      <section class="form-area">
        <v-container class="py-0">
          <v-row justify="center">
            <v-col cols="12" md="6" sm="8" >
              <v-form v-model="valid" ref="form" onsubmit="return false;">
                <p>휴대폰번호</p>
                <div class="d-flex">
                  <v-select
                    :items="items" 
                    item-text="text" 
                    item-value="value" 
                    v-model="teleCoCd" 
                    solo
                  />
                  <v-text-field
                    ref="cellTelNo"
                    v-model="cellTelNo"
                    :rules="rules.cellTelNoRules"
                    label="'-'를 제외하고 입력"
                    mask="###########"
                    required
                    solo
                    maxlength="11"
                  />              
                </div>
                <div class="check-all">
                  <v-checkbox label="모든 약관 동의" v-model="chk_all" @click.stop="(chk_all = !chk_all), checkAll()" />
                </div>
                <v-divider class="mt-2 mb-5" />
                <div class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a1" hide-details @click.stop="(chk_a1 = !chk_a1), checkBoxCheck()" :rules="[(v) => !!v || '필수 약관에 동의해주세요']">
                    <template v-slot:label>
                      <div>서비스 이용약관(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto" @click.stop="showTerms({termsCd: '111', prdtNo: 'B001', teleCoCd: '1'})">
                    <v-icon>mdi-chevron-right</v-icon>
                  </div>
                </div>
                <div class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a2" hide-details @click.stop="(chk_a2 = !chk_a2), checkBoxCheck()" :rules="[(v) => !!v || '필수 약관에 동의해주세요']">
                    <template v-slot:label>
                      <div>서비스알림수신동의(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto" @click.stop="showTerms({termsCd: '112', prdtNo: 'B001', teleCoCd: '1'})">
                    <v-icon>mdi-chevron-right</v-icon>
                  </div>
                </div>
                <div class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a3" hide-details @click.stop="(chk_a3 = !chk_a3), checkBoxCheck()" :rules="[(v) => !!v || '필수 약관에 동의해주세요']">
                    <template v-slot:label>
                      <div>프로미고객사랑보험가입동의(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto" @click.stop="showTerms({termsCd: '113', prdtNo: 'B001', teleCoCd: '1'})">
                    <v-icon>mdi-chevron-right</v-icon>
                  </div>
                </div>
                <div class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a4" hide-details @click.stop="(chk_a4 = !chk_a4), checkBoxCheck()" :rules="[(v) => !!v || '필수 약관에 동의해주세요']">
                    <template v-slot:label>
                      <div>프로미고객사랑보험가입약관확인(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto" @click.stop="showTerms({termsCd: '114', prdtNo: 'B001', teleCoCd: '1'})">
                    <v-icon>mdi-chevron-right</v-icon>
                  </div>
                </div>
                <div class="recaptcha-area">
                  <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                  <div class="v-messages theme--light error--text mt-2">
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message" v-if="!recaptchaVerifyCheck">로봇이 아닙니다를 체크해주세요</div>
                    </div>
                  </div>
                </div>
                <div>
                  <v-btn class="submit" rounded block large depressed color="primary" @click.stop="submit()">가입하기</v-btn>
                </div>
                <p class="mt-8 text-center">매월 2,500원 (VAT포함)</p>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <div class="mb-16">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" md="4" sm="6">
              <div class="text-center term-btn">
                <v-btn text @click.stop="showTerms({termsCd: '002', prdtNo: 'B001', teleCoCd: '1'})">서비스이용약관</v-btn>
                <span class="mx-1">|</span>
                <v-btn text @click.stop="showTerms({termsCd: '003', prdtNo: 'B001', teleCoCd: '1'})">개인정보처리방침</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </template>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";

export default {
  name: "SafebillingContract",
  data: () => ({
    items: [
      { text: 'SKT', value: '1' }
    ],
    valid: false,
    recaptchaVerify: false,
    recaptchaVerifyCheck: true,
    teleCoCd: "1",
    cellTelNo: "",
    chk_all: false,
    chk_a1: false,
    chk_a2: false,
    chk_a3: false,
    chk_a4: false,
    rules: {
      cellTelNoRules: [(v) => !!v || "휴대폰번호를 입력하세요.", (v) => (v && v.length >= 11 && /(01[0])([1-9]{1}[0-9]{2,3})([0-9]{4})$/.test(v)) || "휴대폰번호가 정확하지 않습니다."]
    },
    timeout: 6000
  }),
  components: {
    Container,
  },
  methods: {
    checkAll() {
      this.chk_a1 = this.chk_all;
      this.chk_a2 = this.chk_all;
      this.chk_a3 = this.chk_all;
      this.chk_a4 = this.chk_all;
    },
    checkBoxCheck() {
      if (this.chk_a1 && this.chk_a2 && this.chk_a3 && this.chk_a4) {
        this.chk_all = true;
      } else {
        this.chk_all = false;
      }
    },
    submit() {
      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();
      if (!this.valid) {
        return false;
      }
      if (!this.recaptchaVerify) {
        return false;
      }

      this.$router.push({
        name: "SafebillingCert",
        params: {
          type: "join",
          cellTelNo: this.cellTelNo
        }
      });
    },
    onVerify(r) {
      this.recaptchaVerify = true;
      this.recaptchaVerifyCheck = this.recaptchaVerify;
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    exec() {
      this.$refs.recaptcha.execute();
    },
    reset() {
      this.$refs.recaptcha.reset();
    }
  }
};
</script>
